import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgMcqIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.1176 12.45V7.32c0-1.5121 0-2.2682-.2885-2.8458-.2537-.508-.6587-.921-1.1568-1.18C17.1061 3 16.3648 3 14.8824 3H9.2353c-1.4825 0-2.2237 0-2.79.2943-.498.2588-.903.6719-1.1568 1.18C5 5.0517 5 5.8078 5 7.32v9.36c0 1.5121 0 2.2682.2885 2.8458.2538.508.6587.9211 1.1568 1.1799C7.0116 21 7.7528 21 9.2353 21h2.8235m1.7647-9.9h-5.294m1.7646 3.6H8.5294m7.0588-7.2H8.5294m5.7353 10.8 1.7647 1.8L20 16.05"
    />
  </svg>
);
export default SvgMcqIcon;
